<template>
  <layout>
    <template v-slot:header>
      <AppHead title="Edit Category" />
      <h2>Edit Category</h2>
      <BreadCrumbs activeItem="Edit Category" :crumbs="{ home: 'Dashboard', categories: 'Categories'}"/>
      <flash-messages />
    </template>
    
    <template v-slot:default>
      <div class="col-12 col-xl-6 px-0">
        <card headerStyle="dark" title="Reorder Categories" v-if="$page.props.categories_sort.length" class="mb-3">
          <p class="mb-2 text-size-small text-primary w-100">
            <i class="fas fa-hand-pointer mr-2"></i>Drag Items to Reorder Categories
          </p>
          <draggable :list="$page.props.categories_sort" item-key="id" :delay="50" class="list-group" @change="changed">
            <template #item="{element}">
              <li class="list-group-item list-group-item-info py-1 cursor-pointer">
                <strong v-if="element.sort_order >= 0">{{element.sort_order+1}} - </strong>{{element.name}}
              </li> 
            </template>
          </draggable>
        </card>
      </div>

      <div class="col-12 col-xl-6 px-0">
        <card icon="fas fa-pencil-alt" title="Edit">
          <form @submit.prevent="update">
            <div class="row">
              <div class="form-group col-12 col-lg-6">
                <jet-label for="name" value="Name" />
                <jet-input id="name"  type="text" class="form-control" v-model="form.name" />
                <jet-input-error :message="form.errors.name" class="mt-2" />
              </div>

              <div class="form-group col-12 col-lg-6">
                <jet-label for="parent_id" value="Parent" />
                <select class="form-control" v-model="form.parent_id">
                  <option :key="-1" :value="null">None</option>
                  <option v-for="category in this.categories" :key="category.id" :value="category.id">
                    {{ category.name }}
                  </option>
                </select>
                <jet-input-error :message="form.errors.parent_id" class="mt-2" />
              </div>
            </div>

            <div class="col-12 d-flex align-items-end my-3">
              <div class="form-check">
                <input type="checkbox" id="active" class="form-check-input" v-model="form.active" />
                <jet-label for="active" value="Active" />
                <jet-input-error :message="form.errors.active" class="mt-2" />
              </div>
            </div>

            <div class="bottom-button">
              <jet-button class="px-5" btnStyle="success" :disable="form.processing" type="submit">Edit Category</jet-button>
            </div>
          </form>
        </card>
      </div>
    </template>
  </layout>
</template>

<script>
  import Layout from '@/Shared/Admin/Layout'
  import FileInput from '@/Shared/FileInput'
  import TextInput from '@/Shared/TextInput'
  import SelectInput from '@/Shared/SelectInput'

  import JetButton from '@/Jetstream/Button'
  import JetFormSection from '@/Jetstream/FormSection'
  import JetInput from '@/Jetstream/Input'
  import JetCheckbox from '@/Jetstream/Checkbox'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'
  import JetActionMessage from '@/Jetstream/ActionMessage'
  import FlashMessages from '@/Shared/FlashMessages'
  import draggable from 'vuedraggable'
  import BreadCrumbs from '@/Shared/BreadCrumbs'

  export default {
    components: {
      FileInput,
      SelectInput,
      TextInput,
      JetActionMessage,
      JetButton,
      JetFormSection,
      JetInput,
      JetCheckbox,
      JetInputError,
      JetLabel,
      Layout,
      FlashMessages,
      draggable,
      BreadCrumbs
    },
    remember: 'form',
    props: {
      category: Object,
      categories: Object
    },
    data() {
      return {
        form: this.$inertia.form({
          _method: 'put',
          name: this.category.name,
          parent_id: this.category.parent_id,
          active: this.category.active == 1
        }),
      }
    },
    mounted() {
      this.sortCategories()
    },
    methods: {
      update() {
        this.form.post(this.route('categories.update', this.category.id))
      },
      sortCategories() {
        this.$page.props.categories_sort.forEach( (elem, index) => { elem.sort_order = index })
      },
      changed() {
        this.sortCategories()
        this.$inertia.post(route('categories.saveorder'), {
          categories:JSON.stringify(this.$page.props.categories_sort),
          }, { preserveScroll: true })
      },
    },
  }
</script>
